import React, { Component, Suspense } from 'react';
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { getHost } from "containers/utils";
import {authCheckState} from "store/actions/signIn/Login";
import { orgLogoGet } from "store/actions/Orglogo/orglogo";
import * as constants from "./Data/constants";
import routes from './urls';
import datatype from "./Data/Createdata";
import MainRoutes from './router/index';
import Spinner from './components/UI/Spinner/Spinner';
import { saveToLocalStorage } from "./localStorage";
import Toast from './components/Toast';
import "antd/dist/antd.css";

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loaded: false
    }
    this.loadComponent = this.loadComponent.bind(this);
  }

  componentDidMount() {
    this.props.onTryAutoSignup(this.loadComponent);

    try {
      if (localStorage.getItem) {
        const themeDataFromLocalStorage = JSON.parse(
          localStorage.getItem(constants.THEME_CONTROLLER)
        );
        if(themeDataFromLocalStorage !== null) {
          this.applyTheme(themeDataFromLocalStorage);
        }
      }
    } catch (exception) {
      // Failed to apply custom theme, applying default theme
    } finally {
      this.props.onGetOrgLogo();
    }

    // HJID => Hotjar ID, HJSV => Hotjar Snippet Version
    // Disabled , since experiment is complete
    // if(process.env.REACT_APP_HJID !== '' && process.env.REACT_APP_HJSV !== '') {
    //   hotjar.initialize(process.env.REACT_APP_HJID, process.env.REACT_APP_HJSV);
    // }      
  }

  componentDidUpdate(prevProps) {
    const themeInfo = this.props.themeInfo;
    if (prevProps.themeInfo !== themeInfo) {
      saveToLocalStorage(this.props.themeInfo, constants.THEME_CONTROLLER);
      this.applyTheme(themeInfo);
    }
  }

  applyTheme(setTheme) {
    if (setTheme.first_primary_color && setTheme.second_primary_color) {
      document.body.style.setProperty("--main-app-gradient-color", `linear-gradient(116deg, ${setTheme.first_primary_color}, ${setTheme.second_primary_color})`);
      document.body.style.setProperty("--main-first-primary-color", `${setTheme.first_primary_color}`);
      document.body.style.setProperty("--main-second-primary-color", `${setTheme.second_primary_color}`);
      document.body.style.setProperty("--main-first-button-color", `${setTheme.first_button_color}`);
      document.body.style.setProperty("--main-button-gradient-color", `linear-gradient(116deg, ${setTheme.first_button_color}, ${setTheme.second_button_color})`);
      document.body.style.setProperty("--main-button-text-color", `${setTheme.button_text_color === "WHITE" ? "#ffffff" : "#000000"}`);
    }
  }

  loadComponent() {
    this.setState({ loaded: true })
  }

  render() {
    const { authUser, history } = this.props;
    if (!this.state.loaded) {
      return <Spinner />
    }
    if (datatype.hostname === getHost()) {

      return (
        <Suspense fallback={<Spinner />}>
          <Route
            exact
            path={routes.REGISTER.path}
            component={routes.REGISTER.component} 
          />
          <Route
            exact
            path={routes.DIGILOCKER.path}
            render={props => <routes.DIGILOCKER.component {...props} />}
          />
        </Suspense>
      )
    }
    return (
      <Suspense fallback={<Spinner />}>
        <Toast />
        <MainRoutes user={authUser} history={history} />
      </Suspense>
    )
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.token !== null,
  authUser: state.auth,
  themeInfo: state.orgLogo.theme
})

const mapDispatchToProps = {
  onTryAutoSignup: authCheckState,
  onGetOrgLogo: orgLogoGet
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
